<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import jsPDF from 'jspdf'
import moment from 'moment';

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        /*let headers = Request.getDefaultHeader(payload);
        let filters = JSON.parse(JSON.stringify(payload.filters));        
        filters.isCount = true;
        
        let response = await Request.do(payload, 'POST', headers, filters, `${Endpoints.orders.holder.listOrdersByStatus}`); 
        n
        payload.pages = Math.ceil(response.data.results[0].count / payload.itemsPerPage);*/

        //carrega todas as cotações pendentes
        
        payload.onChangeDay();
        payload.filter();
        setInterval(() => payload.filter(), 60000);

    },
    methods:{
        filter: async function(page){
            let state = this;
            state.items = [];

            let headers = Request.getDefaultHeader(state);
            if (page)
                this.currentPage = page;
            
            if(!this.filters.beginDate) {            
                this.filters.skip = this.currentPage;
                this.filters.limit = this.itemsPerPage
            } else {
                delete this.filters.skip
                delete this.filters.limit
            }
            
            let filters = JSON.parse(JSON.stringify(this.filters));
            //console.log('PAYLOAD', filters);
            if(this.nDays === 'customized') {

                if(this.filters.beginDate == null || this.filters.endDate == null) {
                    alert('Informe um intervalo de datas válido');
                    return;
                }

                if(moment(this.filters.beginDate).isAfter(moment(this.filters.endDate))) {
                    alert('A data inicial deve ser menor que a data final');
                    return;
                }

            }

            Request.do(state, 'POST', headers, filters, `${Endpoints.orders.holder.listOrdersByStatus}`,
            (response)=>{//SUCCESS CALLBACK
                console.log(response);
                state.items = response.results;                
                // if(state.items.length > state.totalOrders && state.totalOrders > 0){
                //     state.newOrder = true;
                // }
                // state.totalOrders = state.items.length;
                
            },
            (error)=>{
                console.log(error);
            });
        },
        selectItem: async function(item){
 
            this.order = item;
            if(item.isSearchByCompany && item.trucker && item.trucker._id){
                await this.getTrucksByUser(item.trucker._id)
            }else{}
            $('#modalOrderPart').modal('show');

        },
        addCompany: function(item){
            this.order = item;
            
            setTimeout(async function(){
                $('#modalAddCompanyPart').modal('show');
            }, 100);
            //this.filter();
        },
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },
        onChangeBeginDate() {
            
        },
        onChangeDay: async function(){
            
            if(this.nDays && this.nDays !== 'customized') {
                let beginDate = new Date();
                beginDate.setDate(beginDate.getDate() - this.nDays);
                this.filters.beginDate = beginDate;                
                
            } else {
                delete this.filters.beginDate;
            }
            this.filters.endDate = new Date();

            // let headers = Request.getDefaultHeader(this);
            // let filters = JSON.parse(JSON.stringify(this.filters));
            // filters.isCount = true;
            // let response = await Request.do(this, 'POST', headers, filters, `${Endpoints.orders.holder.listOrdersByStatus}`); 
            // this.pages = Math.ceil(response.data.results[0].count / this.itemsPerPage);

            //this.filter();
        },
        checkClose: function(item){
            return (item.statusOrder.toUpperCase() != 'CLOSED' && item.statusOrder.toUpperCase() != 'PAID' && item.statusOrder.toUpperCase() != 'REJECTED' )
            return null;
        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.close.order.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            this.orderSelected = item;
            
            setTimeout(async function(){
                $('#confirmationCloseHolderPart').modal('show');
                }, 100);
        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;

                Request.do(this, 'POST', Request.getDefaultHeader(this), {isCloseAllOrders:true, justifyClose:this.orderSelected.justifyClose} , `${Endpoints.orders.closeholder}${this.orderSelected._id}`,
                    (companyResponse)=>{//SUCCESS CALLBACK
                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
        },

        download: function(item){

            // var getImageFromUrl = function(url, callback) {
            //     var img = new Image, data, ret={data: null, pending: true};
                
            //     img.onError = function() {
            //         throw new Error('Cannot load image: "'+url+'"');
            //     }
            //     img.onload = function() {
            //         var canvas = document.createElement('canvas');
            //         document.body.appendChild(canvas);
            //         canvas.width = img.width;
            //         canvas.height = img.height;

            //         var ctx = canvas.getContext('2d');
            //         ctx.drawImage(img, 0, 0);
            //         // Grab the image as a jpeg encoded in base64, but only the data
            //         data = canvas.toDataURL('image/jpeg').slice('data:image/jpeg;base64,'.length);
            //         // Convert the data to binary form
            //         data = atob(data)
            //         document.body.removeChild(canvas);

            //         ret['data'] = data;
            //         ret['pending'] = false;
            //         if (typeof callback === 'function') {
            //             callback(data);
            //         }
            //     }
            //     img.src = url;

            //     return ret;
            // }
            

           
            let pdfName = 'certificado - '+String(item._id);
            var doc = new jsPDF();
            let total = item.paymentObject.amount_br.toString();
            let companyAddress = item.company.address.address + ' ' + item.company.address.number + ', ' + item.company.address.neighborhood +
             ' ' + item.company.address.cep + ', ' + item.company.address.city + ' - ' + item.company.address.state;  
            let customerName = "";
            if(item.systemUser.firstName!=null)
            { customerName = item.systemUser.firstName;}
            if(item.systemUser.lastName!=null)
            { customerName = customerName + ' ' + item.systemUser.lastName; }
            
            
            // console.log(this.nameItem);
            doc.setProperties({
                title: 'Certificado',
                subject: 'Certificado',		
                author:  item.company.socialName,
                keywords: 'generated, javascript, web 2.0, ajax',
                creator: 'SOS Truck'
            });
         
            doc.setFontSize(20);
            doc.text(15, 15, this.$t('string.text.order.paid.recive'));	
            doc.text(130, 15, this.$t('string.text.order.paid.number.order'));
            doc.setFontSize(12);
            doc.setTextColor(0);
            doc.text(15, 40, this.$t('string.text.order.paid.by'));
            doc.text(15, 55, this.$t('string.text.order.delivery.options'));
            doc.text(15, 80, this.$t('string.text.order.company'));
            doc.setFontSize(10);
            doc.text(130,80, this.$t('string.text.order.status') + ' ' + this.toUpperCase(this.$t(item.transactionStatusCode)));		
            doc.setFontSize(12);
            doc.text(130, 40, this.$t('string.text.order.details'));
            doc.setFontSize(20);
            doc.text(130, 60, this.$t('string.text.order.paid.total'));
            doc.text(165, 60, String(total));	
            doc.setFontSize(12);
            doc.setTextColor(120);
            doc.text(130, 21, String(item._id));	
            doc.setFontSize(8);
            doc.text(130, 45, String(item.certified.name));	
            doc.setFontSize(12);
            doc.text(130, 66, String(this.$t(item.paymentMethod)));
             doc.text(130, 71, String(this.$t(item.paymentType)));
            doc.text(15, 60, String(this.$t(item.deliveryMethod)));	
            doc.text(15, 85, String(item.company.socialName));
            doc.setFontSize(10);	
            doc.text(15, 90,companyAddress);
            doc.text(15, 95,item.company.primaryPhone + ' - ' + item.company.email);
            doc.setFontSize(12);
            doc.text(15, 45, String(customerName));
            doc.text(15, 21, this.$t('string.text.order.date'));
            doc.text(57, 21, String(item.paymentObject.confirm_date));
            doc.text(165, 45,String(total));
            doc.save(pdfName + '.pdf');

        },
        onChange: function(){
            this.filter();
        },
        load(){
            this.time = (this.filter());
            if(this.newOrder){
                this.playSound();
                this.newOrder = false;
            }
        },
        playSound: function(){
            var audio = new Audio('http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3');
            audio.play();
        },
        // searchStatus: function(){
        //     for (var i = 0; i < this.order.orders.length; i++) {
        //         if(order.orders[i].statusOrder=="WAITING_FOR_RESPONSE" && this.statusOrder == null)
        //         {   this.statusOrder = order.orders[i].statusOrder;}
        //         if(order.orders[i].statusOrder=="ANSWERED" && (this.statusOrder == "WAITING_FOR_RESPONSE" || this.statusOrder == null) )
        //         {    this.statusOrder = order.orders[i].statusOrder;}
        //         if(order.orders[i].statusOrder=="PAID" && (this.statusOrder == "ANSWERED" || this.statusOrder == "WAITING_FOR_RESPONSE" ||  this.statusOrder == null) )
        //         {    this.statusOrder = order.orders[i].statusOrder;}
        //     }
        //     console.log(this.statusOrder);

        // },
        showMesage: function(result){
            if(result == 1){
                $('#modalAddCompanyPart').modal('toggle');
                this.flashMessage.success(
                    this.configMessage(this.$t('string.msg.addCompany.register.title.success'), this.$t('string.msg.addCompany.register.message.success'), 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.addCompany.register.message.success')),
                            destroyed: this.clearText()
                        })
            } else if(result == 2){
                $('#modalAddCompanyPart').modal('toggle');
                this.flashMessage.error(
                    this.configMessage(this.$t('string.msg.addCompany.register.title.error'), this.$t('string.msg.addCompany.register.message.error'), 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.addCompany.register.message.error')),
                            destroyed: this.clearText()
                        })
            }
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
